// extracted by mini-css-extract-plugin
export default {"output-controls":"OutputControls_output-controls__yuaSi"};